import GrtDiv from './grt-div';
export default GrtDiv;
